import type { SafetyReportOutcomeContext } from '../../pages/safetyReportOutcomeContext';
import { isDemoOrLoopedSourceContext, resolveSafetyReportOutcomeContext } from '../../pages/safetyReportOutcomeContext';

export function resolveExternalOutcomeContext(isDemoOrLoopedSource: boolean): SafetyReportOutcomeContext {
  if (!isDemoOrLoopedSource) {
    return resolveSafetyReportOutcomeContext({});
  }
  const sourceContext = {
    source_type: 'controlled_demo',
    non_production_mode: true,
    risk_reduction_claim_allowed: false,
  };
  if (!isDemoOrLoopedSourceContext(sourceContext)) {
    return resolveSafetyReportOutcomeContext({});
  }
  return resolveSafetyReportOutcomeContext({
    technicalDetails: { source_context: sourceContext },
  });
}
